import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin-bottom":"1em"}
}
const _hoisted_2 = { class: "calendar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Repeat")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "What weekday?")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "What weekday of month?")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "What month?")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "What if holiday?", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Dismiss"),
  /*#__PURE__*/_createElementVNode("span", null, "Move next"),
  /*#__PURE__*/_createElementVNode("span", null, "Move previous")
], -1)
const _hoisted_9 = { key: 1 }

import { onMounted, reactive, ref } from 'vue'
import { WorkspaceRmodel } from '@/app.context/workspace.rmodel'
import { Guid } from '@/lib';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { GroupRmodel } from '@/app.context/workspace/persons.set/group.rmodel';
import { Appointment } from '@/logic/workspaces/appointment';
import { IWorkspaceStorage } from "@/io/storages";
import MeetingParticipantsPicker from '@/components/Workspaces/_spec/MeetingParticipantsPicker.vue'
import { Category } from '@/logic/workspaces/persons/_def'
import { context_workspace } from '@/_dev/config';
import { useAppContext } from '@/app/_tech';
import TimePlannerComponent from "@/components/infra/TimePlannerComponent.vue"
import { roundToClosestQuarterHour } from '@/lib/date';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentCreator',
  props: {
    workspace: {},
    storage: {},
    date: {},
    category: {}
  },
  emits: ['submit', 'cancel'],
  setup(__props: any, { emit: __emit }) {

const context = useAppContext();

const props = __props

const participants = ref<InstanceType<typeof MeetingParticipantsPicker> | null>(null)




const request: {

    //time_text_hour: string,
    //time_text_minute: string,
    datetime:Date,
    span: number

    days: { mon1: boolean, tue2: boolean, wed3: boolean, thr4: boolean, fri5: boolean, sat6: boolean, sun7: boolean },
    monthly: { W1: boolean, W2: boolean, W3: boolean, W4: boolean, last: boolean },
    yearly: { M01: boolean, M02: boolean, M03: boolean, M04: boolean, M05: boolean, M06: boolean, M07: boolean, M08: boolean, M09: boolean, M10: boolean, M11: boolean, M12: boolean },


} =
    reactive({
        time_text_hour: '',
        time_text_minute: '',
        datetime: props.date ?? new Date(),
        days: { mon1: false, tue2: false, wed3: false, thr4: false, fri5: false, sat6: false, sun7: false },
        monthly: { W1: false, W2: false, W3: false, W4: false, last: false },
        yearly: { M01: false, M02: false, M03: false, M04: false, M05: false, M06: false, M07: false, M08: false, M09: false, M10: false, M11: false, M12: false },
        persons: new Set<PersonRmodel>(),
        groups: new Set<GroupRmodel>(),
        span:0

    })

const emit = __emit

function create() {

    props.storage!.appointmentCreate(props.workspace!.wid, appointment())

    emit('submit')
}

function cancel(){

    console.log('cancel from a creator')
    emit('cancel')
}


onMounted(()=>{

    request.datetime = roundToClosestQuarterHour(new Date(), 'forward')
})

function appointment() {


    //const x : { persons:Guid[], groups:Guid[], weekdays:number[], monthly:number[], yearly:number[]} = { persons:[], groups:[], weekdays:[], monthly:[], yearly:[]}

    const x: Appointment = new Appointment()

    x.category = props.category ?? ''


    const prmt = context.prompt ?? null

    if (prmt != null) x.name = prmt()
    

    //x.name

    // const ui =
    // {
    //     hours: parseInt(request.time_text_hour),
    //     minutes: parseInt(request.time_text_minute)
    // }

    // const d = new Date(props.date!.getFullYear(), 1, 1, 0, 0)

    // //we setup time as 'utc' so it was passed to server in 'local' value - but togehter with timezone at a.timezone

    // d.setUTCFullYear(props.date!.getFullYear())
    // d.setUTCMonth(props.date!.getMonth())
    // d.setUTCDate(props.date!.getDate())

    // d.setUTCHours(ui.hours) 
    // d.setUTCMinutes(ui.minutes)
    // d.setUTCMilliseconds(0)

    x.datetime = request.datetime //d
    x.uid = Guid.newGuid()

    //const offset = request.datetime.getTimezoneOffset()

    const utcDate = x.datetime.getUTCDate()



    let c = 0 //'correction'

    if (utcDate < x.datetime.getDate()) c = -1;
    if (utcDate > x.datetime.getDate()) c = +1;

    if (request.days.mon1) x.weekdays.push(c == 0 ? 1 : (c > 0 ? 2 : 7))

    if (request.days.tue2) x.weekdays.push(2 + c)
    if (request.days.wed3) x.weekdays.push(3 + c)
    if (request.days.thr4) x.weekdays.push(4 + c)
    if (request.days.fri5) x.weekdays.push(5 + c)
    if (request.days.sat6) x.weekdays.push(6 + c)

    if (request.days.sun7) x.weekdays.push(c == 0 ? 7 : (c > 0 ? 1 : 6))

    if (request.monthly.W1) x.monthly.push(1)
    if (request.monthly.W2) x.monthly.push(2)
    if (request.monthly.W3) x.monthly.push(3)
    if (request.monthly.W4) x.monthly.push(4)
    if (request.monthly.last) x.monthly.push(-1)


    if (request.yearly.M01) x.yearly.push(1)
    if (request.yearly.M02) x.yearly.push(2)
    if (request.yearly.M03) x.yearly.push(3)
    if (request.yearly.M04) x.yearly.push(4)
    if (request.yearly.M05) x.yearly.push(5)
    if (request.yearly.M06) x.yearly.push(6)
    if (request.yearly.M07) x.yearly.push(7)
    if (request.yearly.M08) x.yearly.push(8)
    if (request.yearly.M09) x.yearly.push(9)
    if (request.yearly.M10) x.yearly.push(10)
    if (request.yearly.M11) x.yearly.push(11)
    if (request.yearly.M12) x.yearly.push(12)


    if (participants.value != null) {

        const buffer = participants.value.participants()

        buffer.persons.forEach(p => x.persons.push(p))
        buffer.groups.forEach(g => x.groups.push(g))
    }

    return x

}




return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (props.workspace != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ((props.category ?? '') == _unref(Category).M)
          ? (_openBlock(), _createBlock(MeetingParticipantsPicker, {
              key: 0,
              workspace: props.workspace,
              ref_key: "participants",
              ref: participants
            }, null, 8, ["workspace"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_date_picker, {
            modelValue: request.datetime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((request.datetime) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(props.date?.toDateString() ?? 'N/A'), 1)
        ]),
        _createVNode(TimePlannerComponent, {
          "model-value": request.datetime,
          span: request.span,
          validator: function(x){ return x.getTime() >= _unref(roundToClosestQuarterHour)(new Date(), 'forward').getTime() }
        }, null, 8, ["model-value", "span", "validator"]),
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((request.days.mon1) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.days.mon1]
              ]),
              _createTextVNode("Mon")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((request.days.tue2) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.days.tue2]
              ]),
              _createTextVNode("Thu")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((request.days.wed3) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.days.wed3]
              ]),
              _createTextVNode("Wed")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((request.days.thr4) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.days.thr4]
              ]),
              _createTextVNode("Thr")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((request.days.fri5) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.days.fri5]
              ]),
              _createTextVNode("Fri")
            ])
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((request.days.sat6) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.days.sat6]
              ]),
              _createTextVNode("Sat")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((request.days.sun7) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.days.sun7]
              ]),
              _createTextVNode("Sun")
            ])
          ])
        ]),
        _hoisted_5,
        _createElementVNode("div", null, [
          _createElementVNode("span", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((request.monthly.W1) = $event))
            }, null, 512), [
              [_vModelCheckbox, request.monthly.W1]
            ]),
            _createTextVNode("1st")
          ]),
          _createElementVNode("span", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((request.monthly.W2) = $event))
            }, null, 512), [
              [_vModelCheckbox, request.monthly.W2]
            ]),
            _createTextVNode("2nd")
          ]),
          _createElementVNode("span", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((request.monthly.W3) = $event))
            }, null, 512), [
              [_vModelCheckbox, request.monthly.W3]
            ]),
            _createTextVNode("3rd")
          ]),
          _createElementVNode("span", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((request.monthly.W4) = $event))
            }, null, 512), [
              [_vModelCheckbox, request.monthly.W4]
            ]),
            _createTextVNode("4th")
          ]),
          _createElementVNode("span", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((request.monthly.last) = $event))
            }, null, 512), [
              [_vModelCheckbox, request.monthly.last]
            ]),
            _createTextVNode("Last")
          ])
        ]),
        _hoisted_6,
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((request.yearly.M01) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M01]
              ]),
              _createTextVNode("Jan")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((request.yearly.M02) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M02]
              ]),
              _createTextVNode("Feb")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((request.yearly.M03) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M03]
              ]),
              _createTextVNode("Mar")
            ])
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((request.yearly.M04) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M04]
              ]),
              _createTextVNode("Apr")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((request.yearly.M05) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M05]
              ]),
              _createTextVNode("May")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((request.yearly.M06) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M06]
              ]),
              _createTextVNode("Jun")
            ])
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((request.yearly.M07) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M07]
              ]),
              _createTextVNode("Jul")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((request.yearly.M08) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M08]
              ]),
              _createTextVNode("Aug")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((request.yearly.M09) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M09]
              ]),
              _createTextVNode("Sep")
            ])
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((request.yearly.M10) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M10]
              ]),
              _createTextVNode("Oct")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((request.yearly.M11) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M11]
              ]),
              _createTextVNode("Nov")
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((request.yearly.M12) = $event))
              }, null, 512), [
                [_vModelCheckbox, request.yearly.M12]
              ]),
              _createTextVNode("Dec")
            ])
          ])
        ]),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", null, [
          _createElementVNode("button", { onClick: create }, "Create"),
          _createElementVNode("button", { onClick: cancel }, "Cancel")
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, "Event creator - no workspace"))
}
}

})